<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-10 15:53:58
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-04-10 16:04:11
 * @Description: 华发底部登录条
 -->
<template>
  <div class="huafa_bottom_login"></div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 49.33px;
  return (designpx / $rem) rem;
}

.huafa_bottom_login {
  width: p2r(375px);
  height: 100px;
  position: fixed;
  left: 0;
  bottom: 200px;
  background-color: red;
}
</style>